import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Helper from "../../helper/Helper";
import AxiosIndicator from "@system/chain/axios-indicator";
import store from "../../storeWire";

export const set_axios_indicator = createAsyncThunk('system__set_axios_indicator', async (running_axios_slug) => {
    let s = store.getState();
    if (AxiosIndicator.register[running_axios_slug] !== undefined) {
        let axios_indicator = { ...s.entities.system.axios_indicator };
        axios_indicator[running_axios_slug] = {
            active: running_axios_slug
        };
        return axios_indicator;
    }
    return false;
});

export const remove_axios_indicator = createAsyncThunk('system__remove_axios_indicator', async (running_axios_slug) => {
    let s = store.getState();
    let axios_indicator = { ...s.entities.system.axios_indicator };
    if (axios_indicator[running_axios_slug] !== undefined) {
        delete axios_indicator[running_axios_slug];
    }
    return axios_indicator;
});

export const remove_system_alert_indicator = createAsyncThunk('remove_alert_indicator', async (param) => {
    let s = store.getState();
    let alert_indicator = { ...s.entities.system.system_alert_list };
    if (Object.keys(alert_indicator).length > 0) {
        delete alert_indicator[param]
    }
    return alert_indicator;
});


const slice = createSlice({
    name: "system",
    initialState: {
        DOMAttachToSystem: {
            event: {},
            system_notification: {},
            latest_system_notification_name: false,
            latest_system_notification_data: false,
            latest_system_notification_UUID: false,
        },
        stateToRedux: {},
        axios_indicator: {},
        system_alert_list: {}
    },
    reducers: {
        system_notification: {
            reducer: (state, action) => {
                let d = {
                    name: action.payload.name,
                    data: action.payload.data,
                    UUID: Helper.UUID()
                };
                state.DOMAttachToSystem.system_notification[action.payload.name] = d;
                state.DOMAttachToSystem.latest_system_notification_name = d.name;
                state.DOMAttachToSystem.latest_system_notification_data = d.data;
                state.DOMAttachToSystem.latest_system_notification_UUID = d.UUID;
            },
        },
        system_alert_indicator: {
            reducer: (state, action) => {
                let data = {}
                data[action.payload.name] = { ...action.payload, id: Helper.UUID() }
                state.system_alert_list = { ...state.system_alert_list, ...data }
            }
        },
        setStateToRedux: {
            reducer: (state, action) => {
                state.stateToRedux[action.payload.name] = action.payload.data;
            },
        },
        clear_all_system_alert: {
            reducer: (state, action) => {
                state.system_alert_list = {}
            }
        }
    },
    extraReducers: {
        [set_axios_indicator.fulfilled]: (state, { payload }) => {
            if (payload) {
                state.axios_indicator = payload;
            }
        },
        [remove_axios_indicator.fulfilled]: (state, { payload }) => {
            state.axios_indicator = payload;
        },
        [remove_system_alert_indicator.fulfilled]: (state, { payload }) => {
            state.system_alert_list = payload;
        }
    },
});

export let { system_notification, setStateToRedux, system_alert_indicator, clear_all_system_alert } = slice.actions;

export default slice.reducer;
